import { useAccountGateStore, type AccountGateFeature } from '@/store/account-gate.store';

/**
 * Opens the guest → account conversion prompt. Mirrors `usePaywall` so call
 * sites read the same way: `const { openAccountGate } = useAccountGate()`.
 */
export function useAccountGate() {
  const openAccountGate = useAccountGateStore((s) => s.openAccountGate);
  return {
    openAccountGate: (feature: AccountGateFeature = 'generic') => openAccountGate(feature),
  };
}
